module.exports = __webpack_public_path__ + "assets/icon_process.ccc58d03.svg";